module.exports = __webpack_public_path__ + "img/chevron-up-20px-dark.956cc0a.svg";